import { useStore } from "@/context/StoreContext";
import { brl } from "@/lib/fmt";
import { BottleStack } from "./Bits";

export const packs = (p) =>
  [1, 2, 3].map((n) => {
    const d = n === 1 ? 0 : n === 2 ? p.d2 : p.d3;
    const unit = p.preco * (1 - d / 100);
    return { n, d, unit, total: unit * n, economia: p.preco * n - unit * n, dias: (p.dias_uso || 30) * n };
  });

export default function BundleOffer({ p, onBuy, label = "Comprar", word = "frasco" }) {
  const { add } = useStore();
  if (p.forma === "kit") return null;
  return (
    <section className="mt-6" data-testid="bundle-offer">
      <h3 className="font-serif text-xl">Leve mais, pague menos</h3>
      <div className="mt-4 grid grid-cols-3 gap-2 sm:gap-3">
        {packs(p).map((k) => (
          <div key={k.n} className={`relative flex flex-col items-center rounded-[22px] border p-2.5 pt-6 text-center sm:p-4 sm:pt-7 ${k.n === 3 ? "border-na-acai bg-na-acai2 ring-2 ring-na-acai/20" : "border-na-line bg-white"}`} data-testid={`bundle-option-${k.n}`}>
            {k.n === 2 && <span className="absolute -top-2.5 rounded-full bg-na-forest px-2.5 py-0.5 text-[10px] font-bold text-white">Mais escolhido</span>}
            {k.n === 3 && <span className="absolute -top-2.5 rounded-full bg-na-acai px-2.5 py-0.5 text-[10px] font-bold text-white">Mais econômico</span>}
            <BottleStack images={[p.imagens?.[0]]} count={k.n} size="h-14 sm:h-20" />
            <p className="mt-2 text-sm font-bold">{k.n} {word}{k.n > 1 ? "s" : ""}</p>
            <p className="text-[11px] text-na-ink2">{k.dias} dias de uso</p>
            <p className="mt-1 text-xs text-na-ink2">{brl(k.unit)}/un.</p>
            <p className="text-base font-bold" data-testid={`bundle-total-${k.n}`}>{brl(k.total)}</p>
            <p className={`text-[11px] font-semibold ${k.economia > 0 ? "text-na-acai" : "text-transparent"}`}>Economize {brl(k.economia)}</p>
            <button onClick={() => (onBuy ? onBuy(k.n) : add(p.slug, k.n, 1, false, "drawer", k.total))} disabled={p.estoque < k.n}
              className={`${k.n === 3 ? "btn-acai" : "btn-na"} mt-2 w-full px-2 py-2 text-xs sm:text-sm`} data-testid={`bundle-buy-${k.n}`}>
              {label === "Quero" ? `Quero ${k.n} ${k.n > 1 ? "potes" : "pote"}` : `${label} ${k.n}`}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
